import type { FaireProductEntity } from "../../entity_types/product";

export const p_c78uqr7stc: FaireProductEntity = {
  token: "p_c78uqr7stc",
  type: "product",
  name: "Pure Arnica Infused Oil",
  brandToken: "b_dowxrh2caf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/aebe65e976523b310abaf3ea2b813cbb6c4a471113c045a684ce274e68699ddc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71fb87a159f31eaf0c61d1c9b016506e8272d851441a2774238c65f972fc3a2c.png",
    "https://cdn.faire.com/fastly/85eb6f0a01e648dc4ac528a3b0ceca5ddb8f1e6e739e1cd4b9fee216bbb12f6a.png",
    "https://cdn.faire.com/fastly/e95c1a17e39cd97343d35a6e69635da0c957b243e815e503046112ee1a5dea2c.png",
    "https://cdn.faire.com/fastly/f08ac1ab8cdf5f2243ea1dcb28e120bd3186849d31187eb91601311a963d3cd8.png",
    "https://cdn.faire.com/fastly/c4bceed9c09fc343c51b9f70f181be5e048f05c0f9428dbecb8768d74b0269a0.png",
    "https://cdn.faire.com/fastly/58120c15b2ac43bf8d0761c00b335a372fc709e2c2841387d1dade2746d0d068.png",
    "https://cdn.faire.com/fastly/ea38936ab68cdb2c69dc5dd063ce02902dcdf1ef5a72035fe16f55ef67f01d01.png",
    "https://cdn.faire.com/fastly/ad7c6048bc6134a348f9673c351a40c5101d5409ee9a3e6aca0eb9ebb698ab77.png",
    "https://cdn.faire.com/fastly/82ef3e58cc686bfd2bc24f08a49c52735c22ebbd168a7bc3c58f1cd9554623b0.png",
    "https://cdn.faire.com/fastly/c75c02acef03202923b122bb851c7d4bbe98c63da15d87e4787b4233922fa04c.png",
    "https://cdn.faire.com/fastly/988bbc36b863f482ff7329eaa404e66cd2edb4cc31237270dc378d93fca36b35.png",
    "https://cdn.faire.com/fastly/3702b02ec112b3a18d10fe7c936d7d514d1a380086eb61ed157f79f01ff57144.png",
    "https://cdn.faire.com/fastly/ecd6f5ce26a75b5c7318e8de1d1a4b52416c17e85c0256d53cde682c7fe75305.png",
    "https://cdn.faire.com/fastly/2f9e615e847be5070085b589b4cd232aa02ec10fbb96b75d5e8c79c9bcd14147.png",
    "https://cdn.faire.com/fastly/cca109a85e8137503dae808af347dc8ce80691f9d1780137afd8dd5f27d89b67.png",
    "https://cdn.faire.com/fastly/77930213362f646385e6706a8deb40a3b0f10424df22a163ba887297fdec0125.jpeg",
  ],
  priceDollars: 15,
  description:
    "\nPure Infused Arnica Oil helps relieve pain, bruising, swelling, strains, and sprains. Premium organic Arnica (Arnica montana) blossoms are infused for a minimum of one month into high quality oils. There are no gels, petroleum, preservatives, or fillers. This is not a homeopathic product. If you can find a better or more effective Arnica Oil on the market, please let us know! We have looked, but not found one.\n\nThis is a great product to use directly on the skin to alleviate pain in cracked, bruised, or broken ribs, as well as for runner’s injuries, joint pains, or tendon issues. Those healing from rotator cuff or other joint surgeries may find this product helpful.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:19.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
